import { render, staticRenderFns } from "./FormattingStep.vue?vue&type=template&id=fdfdef3e"
import script from "./FormattingStep.vue?vue&type=script&lang=js"
export * from "./FormattingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports